<lta-modal-layout
        (escapePress)="onCancel.emit()"
        (layoutClick)="onCancel.emit()"
>
    <lta-modal
            (onClose)="onCancel.emit()"
            class="modal"
    >
        <div class="title">{{'lta-drivers.selectAnchorPoint' | translate}}</div>
        <div class="body">
            <lta-tree
                    #tree
                    [options]="treeOptions"
            ></lta-tree>
        </div>
        <div
                *ngIf="withSelect"
                class="actions"
        >
            <lta-btn
                    (onClick)="onCancel.emit()"
                    size="md"
                    theme="secondary"
            >{{ 'lta.cancel' | translate }}</lta-btn>
            <lta-btn
                    (onClick)="onSave.emit(selectedDriverTreeItem)"
                    [disabled]="!selectedDriverTreeItem"
                    size="md"
                    theme="primary"
            >
                {{ 'common.confirm' | translate }}
            </lta-btn>
        </div>
    </lta-modal>
</lta-modal-layout>
